const ActivationStatus = {
  ACTIVATED: "ACTIVATED",
  PENDING: "PENDING",
  NOT_ACTIVATED: "NOT_ACTIVATED",
  DEACTIVATED: "DEACTIVATED"
};

export default ActivationStatus;
